var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15325 14C9.03604 14.2021 8.86781 14.3698 8.6654 14.4864C8.46299 14.603 8.2335 14.6643 7.99992 14.6643C7.76633 14.6643 7.53685 14.603 7.33443 14.4864C7.13202 14.3698 6.96379 14.2021 6.84659 14M14.6666 11.3333H1.33325C1.86368 11.3333 2.37239 11.1226 2.74747 10.7476C3.12254 10.3725 3.33325 9.86378 3.33325 9.33334V6.00001C3.33325 4.76233 3.82492 3.57535 4.70009 2.70018C5.57526 1.82501 6.76224 1.33334 7.99992 1.33334C9.2376 1.33334 10.4246 1.82501 11.2998 2.70018C12.1749 3.57535 12.6666 4.76233 12.6666 6.00001V9.33334C12.6666 9.86378 12.8773 10.3725 13.2524 10.7476C13.6274 11.1226 14.1362 11.3333 14.6666 11.3333Z",
    stroke: "#FF5917",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.2803faabb17e9bec77a91780d25c6b7c.svg";
export { ForwardRef as ReactComponent };